import styled from "styled-components";
import { Card } from "antd";
import { COLORS } from "../../constants/colors";

export const MoreContent = styled.div`
  
`;

export const CustomCard = styled.div`
  background: white;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 24px 16px;
  border: 1px solid ${props => props.active ? COLORS.$mainBlue : '#eaeaea'};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    border-color: ${COLORS.$mainBlue};
  }

  h4 {
    margin: 16px 0 0;
    color: ${COLORS.$textPrimary};
    text-align: center;
    font-weight: 500;
    font-size: 16px;
  }

  svg {
    transition: all 0.2s ease;
    color: ${COLORS.$textPrimary};
  }

  &:hover svg {
    color: ${COLORS.$mainBlue};
    transform: scale(1.1);
  }
`;

export const CardContainer = styled.div`
  margin: 15px 0 15px;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  padding: 8px 0;
  font-size: 20px;
  font-weight: 600;
  color: ${COLORS.$textPrimary};
  letter-spacing: -0.02em;
`;

export const Section = styled.div`
  margin-top: 24px;
  
  &:first-child {
    margin-top: 0;
  }
`;

export const AccountCard = styled(Card)`
  margin-bottom: 16px;
  border-radius: 12px;
  background: linear-gradient(135deg, #1a2a6c 0%, #2a4858 100%);
  color: white;
  border: none;
  overflow: hidden;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%);
    pointer-events: none;
  }

  .ant-card-body {
    padding: 24px;
  }

  .ant-card-meta-title, 
  .ant-card-meta-description {
    color: white;
  }

  h4 {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 4px;
  }

  p {
    opacity: 0.9;
    font-size: 14px;
  }
`;

// Updated Button Styles for Settings and Logout
export const MenuButton = styled.button`
  width: 100%;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 25px 15px;
  background: white;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: ${COLORS.$textPrimary};

  svg {
    font-size: 18px;
    margin-right: 12px;
    color: ${COLORS.$textSecondary};
    transition: all 0.2s ease;
  }

  &:hover {
    background: ${COLORS.$backgroundHover};
    border-color: ${COLORS.$mainBlue};

    svg {
      color: ${COLORS.$mainBlue};
    }
  }

  &:active {
    transform: scale(0.98);
  }
`;

// Container for the menu buttons
export const MenuButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`;

// Optional: Add this for consistent spacing in the modal
export const ModalSection = styled.div`
  & + & {
    margin-top: 32px;
  }
`;